import React from "react";
import LanguageSelector from "./LanguageSelector";

/**
 * PageHeader
 * - Sticky by default. Pass sticky={false} to disable.
 * - Control offset with topClass (e.g., "top-12"). Defaults to "top-0".
 */
export default function PageHeader({
  title,
  right = null,
  left = null,
  children = null,
  className = "",
  sticky = true,
  topClass = "top-0",
  showLanguageSelector = true,
}) {
  const stickyClasses = sticky
    ? `sticky ${topClass} z-10 page-header-shell`
    : "";
  const hasRightContent = Boolean(right) || showLanguageSelector;

  return (
    <div className={`-mx-2 px-2 py-3 mb-3 sm:-mx-4 sm:px-4 md:-mx-6 md:px-6 ${stickyClasses} ${className}`}>
      {(title || hasRightContent || left) && (
        <div className="flex items-center justify-between gap-3">
          {left || title ? (
            <div className="min-w-0 inline-flex items-center gap-2">
              {left || null}
              {title ? (
                <h2 className="page-title mb-0 truncate">
                  {title}
                </h2>
              ) : null}
            </div>
          ) : (
            <span />
          )}
          {hasRightContent && (
            <div className="shrink-0 inline-flex items-center gap-2">
              {right}
              {showLanguageSelector && <LanguageSelector compact />}
            </div>
          )}
        </div>
      )}
      {children && <div className="mt-2">{children}</div>}
    </div>
  );
}
